<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="icheck radio-group">
          <input
            type="radio"
            name="pix"
            @change="changePix()"
            id="cpf_key"
            :value="pixKeys.PIX_CPF"
            v-model="pixModel.pix"
          />
          <label class="radio-label">{{ 'CPF:' }}</label>
          <label for="cpf_key" style="cursor: pointer"
            ><h6 id="text_cpf"></h6
          ></label>
        </div>
      </div>
      <div class="col-md-12">
        <div class="icheck radio-group">
          <input
            type="radio"
            name="pix"
            data-test="email_pix"
            @change="changePix()"
            :value="pixKeys.PIX_EMAIL"
            id="email_key"
            v-model="pixModel.pix"
          />
          <label class="radio-label">{{ 'Email:' }}</label>
          <label for="email_key" style="cursor: pointer"
            ><h6 id="text_email"></h6
          ></label>
        </div>
      </div>
      <div class="col-md-12">
        <div class="icheck radio-group">
          <input
            type="radio"
            name="pix"
            @change="changePix()"
            :value="pixKeys.PIX_PHONE"
            id="phone_key"
            v-model="pixModel.pix"
          />
          <label class="radio-label">{{ 'Número do Celular:' }}</label>
          <label for="phone_key" style="cursor: pointer"
            ><h6 id="text_phone"></h6
          ></label>
        </div>
      </div>
      <div class="col-md-12">
        <div class="row row-cnpj">
          <div class="icheck radio-group col-md-4">
            <input
              type="radio"
              name="pix"
              @change="changePix()"
              :value="pixKeys.PIX_CNPJ"
              id="cnpj_key"
              v-model="pixModel.pix"
            />
            <label class="radio-label">CNPJ </label>
            <label for="cnpj_key" style="cursor: pointer"
              ><h6 id="text_cnpj"></h6
            ></label>
          </div>
          <div
            v-show="showCNPJ"
            class="input-group col-md-8"
          >
            <input
              v-mask="['##.###.###/####-##']"
              type="text"
              class="form-control cnpj"
              name="document"
              data-test="document"
              placeholder="CNPJ"
              v-model.trim.lazy="pixModel.cnpj"
              id="document"
            />
            <div class="input-group-addon" ref="document_individual_icon">
              <font-awesome-icon icon="user" />
            </div>
          </div>
          <div class="error align-right" v-show="pixModel.invalidCNPJ">
            CNPJ inválido
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Vuetify from 'vuetify';
import VueFormWizard from 'vue-form-wizard';
import axios from 'axios';
import Swal from 'sweetalert2';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import 'vue2-datepicker/locale/pt-br';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/index.css';
import _ from 'lodash';
import { pixKeys, pixModel } from './data/model';
import { validateCnpj } from './data/methods';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

Vue.use(Vuetify);

Vue.use(VueFormWizard);

export default {
  components: {
    FontAwesomeIcon,
  },
  props: {
    pixModel: Object,
    base_url: String,
    providerId: Number | String,
  },
  vuetify: new Vuetify(),
  data() {
    return {
      lang: 'pt-br',
      pixKeys,
      showCNPJ: false,
    };
  },
  methods: {
    changePix() {
      this.showCNPJ = this.pixModel.pix === this.pixKeys.PIX_CNPJ; 
    },
    validate() {
      return this.pixKeys.PIX_CNPJ === this.pixModel.pix
        ? validateCnpj(this.pixModel.cnpj)
        : true;
    },
    trans(key) {
      return _.get(window.lang, key, key);
    },
    async save() {
      if (!this.validate()) {
        this.pixModel.invalidCNPJ = true;
        return false;
      }
      Swal.fire({
        text: 'Salvando PIX...',
      });
      Swal.showLoading();

      var formData = new FormData();
      formData.append('origin', 'web');

      if (this.providerId) formData.append('provider_id', this.providerId);

      formData.append('pix', this.pixModel.pix);
      if (this.pixModel.pix === this.pixKeys.PIX_CNPJ)
        formData.append('cnpj', this.pixModel.cnpj);

      try {
        var json_result = await axios.post(
          this.base_url + '/api/v2/provider/wizard/save_pix',
          formData,
          {
            crossDomain: true,
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        if (json_result.data.success == true) {
          this.providerId = json_result.data.provider.id;
          Swal.close();
          return true;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: json_result.data.errors,
          });

          return false;
        }
      } catch (error) {
        alert(error);
        Swal.close();
        return false;
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="./register.css"></style>
<style>
@import 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900';
@import 'https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css';
@import 'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css';
</style>
